/* eslint-disable */
import * as React from "react";
import { Article } from "./Article";
import { useParams } from "@thd-olt-component-react/router";
import { ArticleRedirector } from "@thd-nucleus/app-render";
import { QueryProvider } from "@thd-nucleus/data-sources";

export const Home = () => {
  const { articleGUID } = useParams();
  return (
    <QueryProvider cacheKey="home">
      <ArticleRedirector articleGUID={articleGUID} />
      <Article />
    </QueryProvider>
  );
};

Home.propTypes = {};

Home.displayName = "HomePage";

Home.defaultProps = {
  name: "",
};
